export const UserPermissionsSet = [
    {
        label: "Visa och ändra annonser",
        value: "listings",
    },
    {
        label: "Visa och inleda transaktioner",
        value: "transactions",
    },
    {
        label: "Visa och lägga till Adresser",
        value: "warehouse",
    },
    {
        label: "Statistics",
        value: "statistics",
    },
    {
        label: "Visa ekonomi och rapporter",
        value: "ekonomi",
    },
];

export const mergeArrays = (arr1, arr2, interval = 4) => {
    let result = [];
    let i = 0;
    let j = 0;

    while (i < arr1.length || j < arr2.length) {
        for (let k = 0; k < interval && i < arr1.length; k++) {
            result.push(arr1[i]);
            i++;
        };

        if (j < arr2.length) {
            result.push(arr2[j]);
            j++;
        };
    };

    return result;
};
